import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import { X } from "lucide-react";
import CanonicalTag from "@/components/CanonicalTag";
const LosAltosPrivateADUClub = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => {
    setShowCalendly(true);
  };
  const closeCalendlyModal = () => {
    setShowCalendly(false);
  };
  useEffect(() => {
    // Add canonical URL
    const canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    canonicalLink.href = 'https://www.udaadu.com/los-altos-private-adu-club';
    document.head.appendChild(canonicalLink);

    // Cleanup
    return () => {
      const existingCanonical = document.querySelector('link[rel="canonical"]');
      if (existingCanonical) {
        existingCanonical.remove();
      }
    };
  }, []);
  return <div className="min-h-screen bg-black">
      <CanonicalTag url="https://www.udaadu.com/los-altos-private-adu-club" />
      <Navigation />

      {/* Calendly Modal */}
      {showCalendly && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4">
          <div className="relative w-full max-w-2xl h-[70vh] bg-white rounded-lg overflow-hidden shadow-xl">
            <button onClick={closeCalendlyModal} className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors">
              <X className="h-6 w-6 text-gray-600" />
            </button>
            <iframe src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" width="100%" height="100%" frameBorder="0" title="Schedule a private consultation" />
          </div>
        </div>}

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-16 text-center">
        {/* Invitation Only Badge */}
        <div className="inline-block mb-8">
          <div className="px-6 py-2 border border-[#e4683b] text-[#e4683b] text-sm font-light tracking-wide uppercase">
            Invitation Only
          </div>
        </div>

        {/* Main Headline */}
        <h1 className="text-5xl font-thin text-white mb-4 leading-tight py-[17px] md:text-6xl">
          Los Altos Private<br />
          <span className="text-[#e4683b] py-0 my-[2px]">ADU Club</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl text-gray-300 font-light mb-16 max-w-2xl mx-auto py-[40px]">
          An exclusive opportunity reserved for select Los Altos homeowners. Limited enrollment. Exceptional returns.
        </p>

        {/* Feature Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          <div className="text-center">
            <h3 className="text-xl font-light text-[#e4683b] mb-3">City Partnership</h3>
            <p className="text-gray-300 font-light py-[16px] my-[5px] px-[50px] mx-[18px] rounded-lg">Exclusive agreements with Los Altos City Hall</p>
          </div>
          <div className="text-center">
            <h3 className="text-xl font-light text-[#e4683b] mb-3">Guaranteed Returns</h3>
            <p className="text-gray-300 font-light">Structured investment opportunities</p>
          </div>
          <div className="text-center">
            <h3 className="text-xl font-light text-[#e4683b] mb-3">Hand-Selected</h3>
            <p className="text-gray-300 font-light">Properties chosen for maximum potential</p>
          </div>
        </div>

        {/* CEO Quote */}
        <div className="bg-gray-900/30 border border-gray-800 rounded-lg p-8 mb-20 max-w-3xl mx-auto py-[63px]">
          <blockquote className="text-lg text-gray-300 font-light italic mb-6 leading-relaxed">
            "We're focusing exclusively on a handful of neighborhood homes to ensure every project receives our full attention and the very best terms."
          </blockquote>
          <cite className="text-[#e4683b] font-light">— M.C. Poudat, CEO & Founder</cite>
        </div>

        {/* Stats Section */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          <div className="text-center">
            <div className="text-4xl font-light text-[#e4683b] mb-2">244%</div>
            <div className="text-gray-300 font-light">Permit Increase</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-light text-[#e4683b] mb-2">Limited</div>
            <div className="text-gray-300 font-light">Enrollment</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-light text-[#e4683b] mb-2">Exclusive</div>
            <div className="text-gray-300 font-light">Partnership</div>
          </div>
        </div>

        {/* Qualification Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-light text-white mb-6">Are You Qualified?</h2>
          <div className="w-24 h-px bg-[#e4683b] mx-auto mb-8"></div>
          <p className="text-lg text-gray-300 font-light max-w-2xl mx-auto leading-relaxed">
            This opportunity isn't for everyone. Book a private consultation to discover if your Los Altos property qualifies for our exclusive club.
          </p>
        </div>

        {/* CTA Button */}
        <Button onClick={openCalendlyModal} className="bg-[#e4683b] hover:bg-[#d55a32] text-white px-12 py-4 text-lg font-light rounded-lg transition-all duration-300 hover:shadow-xl hover:shadow-[#e4683b]/20">
          Book Private Consultation
        </Button>

        {/* Disclaimer */}
        <p className="text-xs text-gray-500 mt-12 max-w-2xl mx-auto">
          Limited time opportunity. Subject to qualification and availability. Terms and conditions apply.
        </p>
      </main>

      <Footer />
    </div>;
};
export default LosAltosPrivateADUClub;